<template>
  <v-layout justify-center>
    <v-btn large color="primary" @click="consultProcessDialog = true">
      Consultar Processo
    </v-btn>
    <v-dialog
      v-model="consultProcessDialog"
      persistent
      width="500"
    >

      <v-card v-if="transactions.length == 0">
        <v-card-title
          class="headline green text--white"
          primary-title
        >
          Consulta de Processo
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="cpfCnpj"
              :mask="cpfCnpj.length >= 12 ? '##.###.###/####-##' : '###.###.###-###'"
              label="CPF / CNPJ"
              type="text"
            />

            <v-text-field
              v-model="processNumber"
              label="Número do Processo"
              @keypress.enter="consult()"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            text
            @click="consultProcessDialog = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading"
            @click="consult()"
          >
            Consultar
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title
          class="headline green text--white"
          primary-title
        >
          Consulta de Processo
        </v-card-title>
        <v-card-text>
          <v-timeline dense clipped>
            <v-timeline-item
              v-for="transaction in transactions"
              :key="transaction.id"
              class="mb-3"
              color="green darken-2"
              icon-color="green darken-2"
              small>
              <v-layout justify-space-between>
<!--                <v-layout column>-->
                  <v-flex xs7>
                    {{ transaction.destination.name }}
                  </v-flex>
<!--                  <v-flex v-if="transaction.to_user" xs7>-->
<!--                    {{ // transaction.to_user.name }}-->
<!--                  </v-flex>-->
<!--                  <v-flex v-else xs7>-->
<!--                    Responsável não encontrado-->
<!--                  </v-flex>-->
                  <v-flex xs3 text-xs-right>{{ transaction.created_at | formatDate }}</v-flex>
<!--                </v-layout>-->
              </v-layout>
            </v-timeline-item>
            <v-timeline-item
              class="mb-3"
              color="grey"
              small>
              <v-layout align-center justify-space-between>
                <v-layout column>
                  <v-flex xs7>
                    {{ transactions[transactions.length-1].origin.name }}
                  </v-flex>
<!--                  <v-flex v-if="transactions[transactions.length-1].from_user" xs7>-->
<!--                    {{ // transactions[transactions.length-1].from_user.name }}-->
<!--                  </v-flex>-->
<!--                  <v-flex v-else xs7>-->
<!--                    Aguardando Recebimento-->
<!--                  </v-flex>-->
                </v-layout>
                <v-flex xs5 text-xs-right>
                  {{ transactions[transactions.length-1].created_at | formatDate }}
                </v-flex>
              </v-layout>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            text
            @click="transactions =[]"
          >
            Voltar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="consultProcessDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>

</template>

<script>
import ApplicationService from '@/services/applications/ApplicationService';

export default {
  name: 'ConsultProcessDialog',
  components: {},
  data() {
    return {
      consultProcessDialog: false,
      loading: false,
      cpfCnpj: '',
      processNumber: '',
      transactions: [],
    };
  },
  methods: {
    consult() {
      this.loading = true;
      console.log(this.cpfCnpj)
      ApplicationService
        .showHistoricNoAuthenticated(this.processNumber, this.cpfCnpj)
        .then((res) => {
          if (res.data.transactions.length === 0) {
            this.$swal({
              type: 'error',
              titleText: 'Processo encontra-se no protocolo e ainda não foi tramitado.',
            });
          } else {
            this.transactions = res.data.transactions;
          }
        })
        .catch(() => {
          this.$swal({
            type: 'error',
            titleText: 'Não foi possível localizar o processo com os dados informados. Verifique se eles estão corretos e tente novamente',
          });
        })
        .finally(() => { this.loading = false; });
    },
  },
};
</script>

<style scoped lang="scss">
  .text--white{
    color: #fff !important;
  }
</style>
